<template>
    <ModalComponent
        :name="name"
        title="Criterios de Riesgo para Preventa"
        v-on:close="() => close(false)"
    >
        <div class="criterios-riesgo-container">
            <div class="alert alert-danger">
                <h5 class="mb-2">
                    <strong>¿CÓMO SE EVALÚA EL RIESGO DE LOS REGISTROS DE PREVENTA?</strong>
                </h5>
                <p class="mb-0">
                    Cada registro recibe una puntuación de riesgo entre 0 y 5 basada en diferentes señales.
                    Cuanto más alta sea la puntuación, mayor es la probabilidad de que el registro sea fraudulento o automatizado.
                </p>
            </div>

            <div class="table-responsive">
                <table class="table table-bordered criterios-table">
                    <thead>
                        <tr style="background-color: #ff3366; color: white;">
                            <th style="width: 40%;">Criterio</th>
                            <th style="width: 15%; text-align: center;">Puntuación</th>
                            <th style="width: 45%;">Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(criterio, index) in criterios" :key="index">
                            <td>{{ criterio.nombre }}</td>
                            <td style="text-align: center;">
                                <strong>{{ criterio.puntuacion }}</strong>
                            </td>
                            <td>{{ criterio.descripcion }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Interpretación -->
            <div class="alert alert-light border">
                <p class="mb-0">
                    <i class="fas fa-lightbulb mr-2"></i>
                    <strong>INTERPRETACIÓN:</strong>
                    Puntuación <strong>0-1</strong> = Bajo riesgo (muy confiable) •
                    <strong>1-3</strong> = Riesgo medio (revisar si es necesario) •
                    <strong>3-5</strong> = Alto riesgo (sospechoso)
                </p>
            </div>
        </div>
    </ModalComponent>
</template>

<script setup>
    import { ref } from 'vue';
    import ModalComponent from '@/components/backend/components/ModalComponent';

    const props = defineProps({
        name: {
            type: String,
            required: true
        }
    });

    const emit = defineEmits(['close']);

    const criterios = ref([
        {
            nombre: 'Dominio de correo poco común',
            puntuacion: '0,2',
            descripcion: 'Email con un proveedor poco común (diferente a Gmail, Hotmail, Outlook, Yahoo, iCloud)'
        },
        {
            nombre: 'Cuenta nueva',
            puntuacion: '0,5',
            descripcion: 'La cuenta del usuario se creó hace menos de 24 horas'
        },
        {
            nombre: 'Registro desde el extranjero',
            puntuacion: '0,5',
            descripcion: 'El registro se realizó desde una IP fuera de España'
        },
        {
            nombre: 'Navegador no estándar',
            puntuacion: '1,5',
            descripcion: 'El navegador no es uno de los estándar (Chrome, Firefox, Safari, Edge, Opera)'
        },
        {
            nombre: 'Patrón repetitivo',
            puntuacion: '2',
            descripcion: 'Más de 2 registros con la misma combinación de IP y User Agent (se penaliza a partir del 3º)'
        },
        {
            nombre: 'Granja de IPs',
            puntuacion: '3',
            descripcion: 'Múltiples registros desde la misma IP (se penaliza a partir del 4º registro)'
        },
        {
            nombre: 'Sin dirección IP',
            puntuacion: '5',
            descripcion: 'No se pudo identificar la dirección IP desde donde se realizó el registro'
        },
        {
            nombre: 'Sin User Agent',
            puntuacion: '5',
            descripcion: 'Falta información del navegador/dispositivo usado para registrarse'
        },
        {
            nombre: 'Bot detectado',
            puntuacion: '5',
            descripcion: 'El User Agent indica que el registro fue realizado por un bot (curl, wget, python, etc.)'
        },
        {
            nombre: 'Historial de compras (REDUCE riesgo)',
            puntuacion: '-1,5',
            descripcion: 'El usuario tiene compras previas en la plataforma, lo cual reduce el riesgo'
        }
    ]);

    const close = () => {
        emit('close');
    };
</script>

<style scoped>
.criterios-riesgo-container {
    font-size: 14px;
}

.criterios-table {
    margin-bottom: 1rem;
}

.criterios-table tbody tr:nth-child(odd) {
    background-color: #f8f9fa;
}

.criterios-table tbody tr:nth-child(even) {
    background-color: #e9ecef;
}

.criterios-table td {
    vertical-align: middle;
    padding: 0.75rem;
}

.criterios-table th {
    padding: 0.75rem;
    font-weight: 600;
}

.alert {
    border-radius: 0.25rem;
}

.alert-danger h5 {
    font-size: 1rem;
}

.alert-danger p {
    font-size: 0.9rem;
}
</style>
